import React from "react";
import ErrorBoundary from "@/components/ErrorBoundary";

/**
 * Per-section boundary for the marketing/home page. If one section throws, only that section is
 * replaced with a small notice — the header, nav and every other section keep rendering. This is
 * the follow-up to the `pools is not defined` crash that blanked the whole homepage.
 */
function SectionFallback() {
  return (
    <section className="os-hairline" data-testid="section-error">
      <div className="max-w-[1240px] mx-auto px-5 py-12 text-center">
        <p className="font-mono uppercase text-[12px] tracking-[0.14em]" style={{ color: "#8E9195" }}>
          This section couldn&apos;t load — the rest of the page is fine.
        </p>
      </div>
    </section>
  );
}

export function SectionBoundary({ children }) {
  return <ErrorBoundary fallback={<SectionFallback />}>{children}</ErrorBoundary>;
}
